import {Injectable} from '@angular/core';
import {GridLayoutService} from '@irb-common/interfaces/grid-layout.service';
import {ModelUsedInRebalanceDialogComponent} from "@irb/irb-editors/editor-portfolio-result/model-used-in-rebalance-dialog/model-used-in-rebalance-dialog.component";
import {UtilityService} from "@irb-common/services/utility.service";
import {DeleteHeaderComponent} from "@irb-common/components/grid/renderers/delete.header.component";
import {DeleteCellComponent} from "@irb-common/components/grid/renderers/delete.cell.component";
import {TruncateTooltipCellComponent} from "@irb-common/components/grid/renderers/truncatetooltip.cell.component";
import {CustomfilterComponent} from "@irb/irb-clients/portfolios/customfilter/customfilter.component";
import {IrbAgSetColumnFilterComponent} from "@irb-common/components/irebal-ag-grid-ent-avatar/irb-ag-set-column-filter/irb-ag-set-filter.component";

@Injectable({
    providedIn: 'root'
})
export class ModelUsedInRebalanceDialogGridLayoutService implements GridLayoutService<ModelUsedInRebalanceDialogComponent> {
    sizeFor: any;

    constructor(private util: UtilityService) {
        this.sizeFor = {
            "symbol": 60
        };
    }

    getFrameworkComponents() {
        return {
            "DeleteHeaderComponent": DeleteHeaderComponent,
            "DeleteCellComponent": DeleteCellComponent,
            "TruncateTooltipCellComponent": TruncateTooltipCellComponent,
            "customFilterToolPanel": CustomfilterComponent,
            "irbAgSetColumnFilterComponent": IrbAgSetColumnFilterComponent
        };
    }

    getColumnDefs(parent: any) {
        return [
            {
                headerName: "Securities",
                flex: 2,
                children: [
                    {
                        headerName: "Symbol",
                        field: "securitySymbol",
                        sort: "asc",
                        comparator: this.util.sortString.bind(parent),
                        cellRenderer : "cellRendererFormatter",
                        headerClass: 'portSummaryModelHistorySymbol',
                        lockPosition: true,
                        maxWidth: 100,
                    },
                    {
                        headerName: "Description",
                        field: "securityDesc",
                        flex: 1,
                        headerClass:'portSummaryModelSymbolDescription',
                        cellRenderer: 'cellRendererFormatter'
                    },
                    {
                        headerName: "Target %",
                        field: "targetPercentage",
                        headerClass: 'editHeaderModelPercent',
                        maxWidth: 100,
                        valueFormatter: (params: any) => {
                            return Number(params.value).toFixed(1);
                        },
                        type: 'numericColumn',
                        editable: false,
                        cellEditor: 'NumericEditorComponent'
                    }
                ]
            },
            {
                headerName: "Rebalance Bands",
                flex: 1,
                headerGroupComponent: 'customHeaderGroup',
                headerGroupComponentParams: {
                    irbColInfo: this.rebalanceBands()
                },
                children: [
                    {
                        headerName: "Min %",
                        field: "minimumPercentage",
                        editable:  false,
                        flex: 1,
                        maxWidth: 100,
                        valueFormatter: (params: any) => {
                            return Number(params.value).toFixed(2);
                        },
                        type: 'numericColumn',
                        headerClass: 'not-right-align',
                        cellEditor: 'NumericEditorComponent'
                    },
                    {
                        headerName: "Max %",
                        field: "maximumPercentage",
                        editable:  false ,
                        valueFormatter: (params: any) => {
                            return Number(params.value).toFixed(2);
                        },
                        type: 'numericColumn',
                        headerClass: 'not-right-align',
                        flex: 1,
                        maxWidth: 100,
                        cellEditor: 'NumericEditorComponent'
                    }
                ]
            }
        ];
    }



    rebalanceBands() {
        let msg= "<p>The minimum and maximum rebalancing band is automatically calculated for each model security using the values set in your global settings.</p>";
        msg += "<p>You can override the calculated bands for any security by deselecting the use default settings checkbox and entering new values.</p>";
        return msg;
    }
}
